import { container } from "tsyringe";
export class UseCaseGetLocations {
    async handle() {
        const getLocations = container.resolve("iGetLocations");
        const locations = await getLocations.handle();
        return locations;
    }
}
